import { useContext } from 'react';
import { ReportsContext } from './ReportsContext';

/**
 * Hook to access Reports domain context
 *
 * Provides safe access to Reports context with error handling.
 * Must be used within ReportsProvider.
 *
 * @returns {ReportsContextType} Context value with state and dispatch
 * @throws {Error} If used outside ReportsProvider
 *
 * @example
 * const { state, dispatch } = useReportsContext();
 * dispatch({ type: ReportsActions.SELECT_REPORT, payload: { report } });
 */
export const useReportsContext = () => {
  const context = useContext(ReportsContext);

  if (!context) {
    throw new Error('useReportsContext must be used within a ReportsProvider');
  }

  return context;
};
